import {AfterViewInit, Component, ElementRef, Inject, Input, ViewChild, ViewEncapsulation} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {OrderControllerService} from "@aparraga/ahoracrypto-api-sdk/sdk";
import {EncryptorService} from "@aparraga/ahoracrypto-client-common/src/app/common/encryptor/encryptor.service";
import {CustomValidators} from "@aparraga/ahoracrypto-client-common/src/app/common/validators/custom.validators";
import {DOCUMENT} from "@angular/common";
import {saveAs} from 'file-saver';

import { Modal } from 'flowbite';

@Component({
    templateUrl: './downloadwallet.component.html',
    styleUrls: ['./downloadwallet.component.scss'],
    selector: 'downloadwallet',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DownloadWalletComponent implements AfterViewInit {

  public _order: any;
  get order(): string {
    return this._order;
  }
  @Input() set order(value: any) {
    this._order = value;
  }

  @Input() secret: string = null;

  public passwordForm: FormGroup;

  @ViewChild('downloadModal') protected downloadModal: ElementRef<HTMLElement>;

  protected modal;

  public constructor(protected orderControllerService: OrderControllerService,
                     protected formBuilder: FormBuilder,
                     protected encryptorService: EncryptorService,
                     protected customValidators: CustomValidators,
                     @Inject(DOCUMENT) private document: Document) {

    this.passwordForm = this.formBuilder.group({
        password:  [null, [Validators.required ]],
        repeatPassword: [null, [Validators.required ]],
      },
      {
        validator: this.customValidators.matchValidator("password", "repeatPassword")
      });

  }

  ngAfterViewInit() {
    this.modal = new Modal(this.downloadModal.nativeElement, {
      backdropClasses: 'bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0',
      onShow: () => {
        this.document.body.classList.add('on-modal');
      },
      onHide: () => {
        this.document.body.classList.remove('on-modal');
      }
    });
  }


  show() {
    this.passwordForm.reset();
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  public downloadWallet() {
    if(this.passwordForm.valid && this.secret != null) {
      let data = {"password": this.passwordForm.get('repeatPassword')?.value};
      this.orderControllerService.orderControllerGetOrderWalletsAsKeystores(this._order.id, data).subscribe(walletsEncrypted => {
        let wallets = this.encryptorService.readFromCipherText(walletsEncrypted, this.secret);
        if(wallets != null && wallets.length == 1) {
          let wallet = wallets[0];
          let blob = new Blob([wallet], {type: "text/plain;charset=utf-8"});
          saveAs(blob, "wallet-keystore.json");
          this.hide();
        }
      });
    }
  }

}
